const ssn = (value) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.toString().replace(/[^\d]/g, '');
  if (onlyNums.length <= 6) {
    return onlyNums;
  }
  return `${onlyNums.slice(0, 6)}-${onlyNums.slice(6)}`;
};

const amount = (value) => {
  if (!value) {
    return value;
  }
  // Replace all non digits with the empty string, then parse to integer to
  // strip out zeros, then parse back to string.
  let onlyNums = value.toString().replace(/[^\d]/g, '');
  if (onlyNums.length > 0) {
    onlyNums = parseInt(onlyNums, 10).toString();
  }
  let formattedNums = '';
  while (onlyNums.length > 3) {
    formattedNums = `.${onlyNums.slice(-3)}${formattedNums}`;
    onlyNums = onlyNums.slice(0, -3);
  }
  formattedNums = `${onlyNums}${formattedNums}`;
  return formattedNums;
};

const number = (value) => {
  if (!value) {
    return value;
  }
  const numbers = value.toString().replace(/[^\d]/g, '');
  return numbers;
};

const creditCard = (value) => {
  if (!value) {
    return value;
  }

  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const matches = v.match(/\d{4,16}/g);
  const match = (matches && matches[0]) || '';
  const parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(' ');
  }

  return value;
};

const normalize = {
  ssn,
  amount,
  number,
  creditCard,
};

export default normalize;
